// src/components/Avatar.js
import React, { useState, useEffect } from "react";
import fallbackAvatar from "assets/img/faces/placeholder.jpg";

export function Avatar({
  src,        // your S3 URL (or undefined)
  alt = "",   // alt text
  size = 110, // width + height in px
  style = {},
  className = "",
}) {
  const [imgSrc, setImgSrc] = useState(src || fallbackAvatar);

  // update local state if `src` prop ever changes
  useEffect(() => {
    setImgSrc(src || fallbackAvatar);
  }, [src]);

  return (
    <img
      src={imgSrc}
      alt={alt}
      className={className}
      style={{
        width: size,
        height: size,
        objectFit: "cover",
        objectPosition: "top center",
        borderRadius: "50%",
        ...style,
      }}
      onError={() => setImgSrc(fallbackAvatar)}
    />
  );
}
